export default function getQuery(str){
    str=str.substring(1,str.length);
    let strArray=str.split("&");
    let query={};
    for(let item  of strArray){
       str=item.split("=");
        query[str[0]]=str[1];
    }
    return query;
}


// WEBPACK FOOTER //
// ./src/utils/query.js